import * as dateFNS from "date-fns";
import { SURVEY_FORM_FIELDS, SURVEY_STATUS } from "../constants";

export const createFormData = ({ values }) => {
  const formData = new FormData();

  const formattedDescription = values[SURVEY_FORM_FIELDS.DESCRIPTION]?.replace(
    /\n/g,
    "<br>"
  );
  const formattedQuestions = (values[SURVEY_FORM_FIELDS.QUESTIONS] || []).map(
    (question) => {
      return {
        id: question?.id,
        title: question.title,
        type_id: question.type.id,
        optional: question.optional,
        order: question.order,
        linear_scale: question.linear_scale,
        select: question.select
      };
    }
  );

  const newStatusID =
    typeof values[SURVEY_FORM_FIELDS.STATUS]?.id !== "undefined"
      ? values[SURVEY_FORM_FIELDS.STATUS].id
      : SURVEY_STATUS.ACTIVE;

  const formattedExpiresIn =
    values[SURVEY_FORM_FIELDS.EXPIRES_IN] &&
    dateFNS.isValid(new Date(values[SURVEY_FORM_FIELDS.EXPIRES_IN]))
      ? `${values[SURVEY_FORM_FIELDS.EXPIRES_IN]}T23:59:59`
      : "";

  formData.append("title", values[SURVEY_FORM_FIELDS.TITLE] || "");
  formData.append("description", formattedDescription);
  formData.append("expires_in", formattedExpiresIn);
  formData.append("status_id", newStatusID);
  formData.append("questions", JSON.stringify(formattedQuestions));
  formData.append("url", values[SURVEY_FORM_FIELDS.SLUG] || "");
  formData.append("config", JSON.stringify(values[SURVEY_FORM_FIELDS.CONFIG] || {}));

  if (values[SURVEY_FORM_FIELDS.TOP_IMAGE_FILE]) {
    formData.append(
      "top_image_file",
      values[SURVEY_FORM_FIELDS.TOP_IMAGE_FILE]
    );
  }

  return formData;
};

export const createUrlFromSurveyName = (name = "") => {
  const from = "àáäâãèéëêìíïîòóöôùúüûñç·/_,:;";
  const to = "aaaaaeeeeiiiioooouuuunc------";

  for (let i = 0, l = from.length; i < l; i++) {
    name = name.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  return name
    .toLocaleLowerCase()
    .trim()
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes
};
